// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3lhSF","inputWrap":"CustomTip_inputWrap__1vEeZ"};